export default __webpack_public_path__ + "static/media/mckinsey-org-forward-program.1249d329.png";